import React from "react";
import { toast } from "react-toastify";

const DeleteOrderModal = ({
  deletingOrder,
  refetch,
  setDeletingOrder,
}) => {
  const { name, _id } = deletingOrder;
  const handleDelete = () => {
    fetch(`https://auto-parts-yer9.onrender.com/order/${_id}`, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.deletedCount) {
          toast.success(`Order  ${name} is deleted`);
          setDeletingOrder(null);
          refetch();
        }
      });
  };
  return (
    <>
      <input
        type="checkbox"
        id="delete-order-modal"
        className="modal-toggle"
      />
      <div className="modal modal-bottom sm:modal-middle z-30 ">
        <div className="modal-box">
          <svg
            className="mx-auto mb-4 w-14 h-14 text-gray-400 dark:text-gray-200"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
          <h3 className=" text-center mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
            Are you sure you want to delete {name} ?
          </h3>

          <div className="flex justify-center items-center">
            <div className="modal-action">
              <button
                onClick={() => handleDelete()}
                className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2"
              >
                Yes, I'm sure
              </button>
            </div>
            <div className="modal-action">
              <label
                htmlFor="delete-order-modal"
                className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
              >
                No, cancel
              </label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteOrderModal;
